<aside class="sidebar-right-wrapper">
    <div class="logout-widget">
      <app-logout></app-logout>
    </div>

    <div class="info-widget">
      <ng-scrollbar autoHeightDisabled="false">
        <app-user-info></app-user-info>
        <app-alert *ngIf="bootstrapLicenseData.getStandardsTypesLeftInfo" className="alert-danger text-center mt-3">
          <span [innerHTML]="bootstrapLicenseData.getStandardsTypesLeftInfo"></span>
        </app-alert>
      </ng-scrollbar>
    </div>
</aside>
